import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { history } from 'app/history';
import { resetLoginDetails } from '../../login/redux/slice';
import { accountDelete, accountUpdate, accountSettings } from './api';

const initialState = {
  loading: false,
  paginationList: [],
  scrollingData: [],
  Settings_user: [],
  sendrequestLoading: false
};

const actions = {
  SETTINGS_ACCOUNT: 'settings_account/SETTINGS_ACCOUNT',
  DELETE_ACCOUNT: 'delete_account/DELETE_ACCOUNT',
  GET_ACCOUNT_SETTINGS: 'getAccountSettings/GET_ACCOUNT_SETTINGS',
  ACTIVATE_ACCOUNT: 'activate_account/ACTIVATE_ACCOUNT'
};

// activate_account/ACTIVATE_ACCOUNT
export const activate_account = createAsyncThunk(
  actions.ACTIVATE_ACCOUNT,
  async (payload) => {
    console.log('payload', payload);
    const response = await accountDelete(`reactivate-user`, payload);
    return response;
  }
);

// getAccountSettings/GET_ACCOUNT_SETTINGS
export const getAccountSettings = createAsyncThunk(
  actions.GET_ACCOUNT_SETTINGS,
  async (payload) => {
    console.log('payload', payload);
    const response = await accountSettings(`get-my-settings`, payload);
    return response;
  }
);

// settings_account/ACCOUNT_SETTINGS
export const settings_account = createAsyncThunk(
  actions.SETTINGS_ACCOUNT,
  async (payload) => {
    console.log('payload', payload);
    const response = await accountUpdate(`save-settings`, payload);
    return response;
  }
);

export const delete_account = createAsyncThunk(
  actions.DELETE_ACCOUNT,
  async (payload, { dispatch }) => {
    try {
      console.log('payload', payload);
      // Make the backend API call for account deletion
      const response = await accountDelete(`deactivate-user`, payload);

      if (response?.success === true) {
        message.success(
          response?.message || 'Your account has been deleted successfully.'
        );
        // Clear local storage upon successful account deletion
        localStorage.clear();

        // Dispatch any Redux action to reset user-related state
        dispatch(resetLoginDetails());

        // Redirect to the login page
        history.push('/login');
      } else {
        // Handle any non-successful response if needed
        console.error('Account deletion failed:', response);
        message.error(response?.message || 'Failed to delete account.');
      }

      return response;
    } catch (error) {
      // Handle any errors that occur during the delete request
      console.error('Error during account deletion:', error);
      throw error; // Optionally, re-throw the error to handle it in the component if needed
    }
  }
);

export const SettingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // createForm
    builder
      .addCase(delete_account.pending, (state) => {
        state.sendrequestLoading = true;
      })
      .addCase(delete_account.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('payload_data', data);
        // state.scrollingData = data;
        state.sendrequestLoading = false;
      })
      .addCase(delete_account.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sendrequestLoading = false;
        message.error(msg);
      });

    // settings_account
    builder
      .addCase(settings_account.pending, (state) => {
        state.sendrequestLoading = true;
      })
      .addCase(settings_account.fulfilled, (state) => {
        // const { success, message: msg } = action.payload;
        state.sendrequestLoading = false;

        // console.log('slice_payload', success);

        // if (!success) {
        //   message.error(msg);
        // } else {
        //   message.success(msg);
        // }
        // console.log('slicelog', data);
      })
      .addCase(settings_account.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sendrequestLoading = false;
        message.error(msg);
      });

    // getAccountSettings
    builder
      .addCase(getAccountSettings.pending, (state) => {
        state.sendrequestLoading = true;
      })
      .addCase(getAccountSettings.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.sendrequestLoading = false;
        state.Settings_user = data;

        // console.log('slice_payload', data);
        // success, message: msg
        // if (!success) {
        //   message.error(msg);
        // } else {
        //   message.success(msg);
        // }
        // console.log('slicelog', data);
      })
      .addCase(getAccountSettings.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sendrequestLoading = false;
        message.error(msg);
      });

    // activate_account
    builder
      .addCase(activate_account.pending, (state) => {
        state.sendrequestLoading = true;
      })
      .addCase(activate_account.fulfilled, (state, action) => {
        const { message: msg } = action.payload;
        state.sendrequestLoading = false;
        message.success(msg);
      })
      .addCase(activate_account.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sendrequestLoading = false;
        message.error(msg);
      });
  }
});

export default SettingsSlice.reducer;
